import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components/dialog';

export const AddBankAccountDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Create
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
